import { motion } from "framer-motion";
import styled, { keyframes } from "styled-components";

export const Container = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  z-index: 15;
  margin-bottom: ${({ theme }) => theme.CONSTANTS.XH * 5}px;
  width: 100%;
  gap: ${({ theme }) => theme.CONSTANTS.XH * 3}px;
  padding: ${({ theme }) => theme.CONSTANTS.XH * 3}px 20px;
  text-align: center;

  @media (min-width: 1025px) {
    align-items: flex-start;
    text-align: left;
    max-width: 1440px;
    margin: ${({ theme }) => theme.CONSTANTS.XH * 5}px auto;
    padding: 0 1vw;
  }
`;

export const CardsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.CONSTANTS.XH * 2}px;
  width: 88%;
`;

export const Title = styled.h3`
  color: ${({ theme }) => theme.THEME.white};
  font-size: ${({ theme }) => theme.CONSTANTS.XR * 25}px;
  font-weight: 600;
  font-family: "Sora", sans-serif;

  @media (min-width: 1025px) {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 10}px;
    margin-bottom: ${({ theme }) => theme.CONSTANTS.XH * 2}px;
  }
`;

const glowPulse = keyframes`
  0% {
    box-shadow: 0 0 0 rgba(0, 217, 255, 0.0);
  }
  50% {
    box-shadow: 0 0 16px rgba(0, 217, 255, 0.5);
  }
  100% {
    box-shadow: 0 0 0 rgba(0, 217, 255, 0.0);
  }
`;

const borderMove = keyframes`
  0% {
    background-position: 0% 50%;
  }
  100% {
    background-position: 200% 50%;
  }
`;
